import { useTranslation } from 'hooks/useTranslation';

export const usePromotionText = () => {
    const { t } = useTranslation();

    function getPromotionText(
        countdown: number | null,
        promotionUntil?: string | null
    ) {
        if (countdown === null) {
            return t('TRANS-exclusive-for-you');
        }

        switch (true) {
            case countdown >= 2:
                return t('TRANS-only-n-days-left', { count: countdown });
            case countdown > 0:
                return t('TRANS-only-today-and-tomorrow');
            case countdown === 0:
                return t('TRANS-only-today');
            case countdown < 0 && promotionUntil !== null:
                return t('TRANS-promotion-extended-until-date', {
                    date: promotionUntil,
                });
            default:
                return t('TRANS-exclusive-for-you');
        }
    }

    return getPromotionText;
};
